<template>
  <!-- v1 -->
  <div>
    <!-- <p>{{tableCols}}</p> -->
    <s-table
      ref="data_list"
      :colDefinitions="tableCols"
      :modx-processor="processor"
      :r-query="processorQuery"
      :pagging="10000"
      :limit="10000"
      :lazyLoader="false"
      :addEmptyLine="false"
      @cell-clicked="clickHandler"
    ></s-table>
  </div>
</template>

<script>
import * as moment from "moment";

export default {
  name: "nav-table",

  props: {
    type: {
      type: String,
      default: "rental",
    },
    context: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      ready: false,
      routeCols: [
        {
          prop: "bk_bookedPrice",
          width: 100,
          label: "Price",

          formatter: function (val, colDefs, row, vm) {
            return vm.$theMoney(val);
          },
        },
        {
          prop: "depts",
          width: 100,
          label: "Dept",

          formatter: function (val, colDefs, row, vm) {
            return vm.$theMoney(val);
          },
        },
        {
          prop: "vehicle_name",
          width: 150,
          label: "Veh.Name",
        },

        {
          prop: "vehicle_type",
          width: 150,
          label: "Type",
        },
        {
          prop: "bk_customer",
          width: 150,
          label: "Customer",
        },
        {
          prop: "endTimeHuman",
          width: 100,
          label: "Drop off",
        },

        {
          prop: "startTimeHuman",
          width: 100,
          label: "Pick Up",
        },
      ],
    };
  },
  computed: {
    processor() {
      return "vue_route/getlist";
    },
    processorQuery() {
      if (this.type == "rental")
        return {
          daterange: "now",
          for: "rental",
          // vehicleGroup: 'Car'
          with: "Vehicle",
          incluedCanceled: false,
          order: "date,startTimeMM,endTimeMM",
          limit: 0,
          dateScope: this.context == "pickup" ? "start" : "end",
        };
    },
    tableCols() {
      const domain = window.Travel.wdb,
        vm = this;
      let cols = [];
      if (this.type == "rental") {
        if (this.context == "pickup")
          cols = this.createArrayFromArray(
            "prop",
            [
              "vehicle_type",
              "vehicle_name",
              "bk_customer",
              "startTimeHuman",
              "bk_bookedPrice",
              "depts",
            ],
            this.routeCols
          );
        else
          cols = this.createArrayFromArray(
            "prop",
            [
              "vehicle_type",
              "vehicle_name",
              "bk_customer",
              "endTimeHuman",
              "bk_bookedPrice",
              "depts",
            ],
            this.routeCols
          );
      }
      return cols;
    },
  },
  methods: {
    clickHandler(e) {
      if (this.type == "rental")
        if ((e.row.vehicle_type, e.row.bk_id))
          this.routeGo({
            query: { rentState: this.context },
            params: {
              transferBookingId: e.row.bk_id,
              vehicleGroup: e.row.vehicle_type.split("-")[0],
            },
            name: "transferBooking",
          });
    },
  },
  created() {
    // _log_("chll..clk...", this.colprops);
    // this.alterClickable = this.colprops ? this.colprops.alterClickable : false;
  },
};
</script>
<style >
.hover-redirect {
  z-index: 20;
  position: absolute;
  left: 2px;
  top: 2px;
}
</style>